"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgConnectOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 21a7 7 0 00-5.42 2.58L12 25a5 5 0 018 0l1.43-1.43A7 7 0 0016 21zM16 14a13.51 13.51 0 00-10.26 4.74l1.42 1.42a11.47 11.47 0 0117.68 0l1.42-1.42A13.51 13.51 0 0016 14z" }),
        React.createElement("path", { d: "M16 7A20 20 0 00.91 13.91l1.42 1.42a17.93 17.93 0 0127.34 0l1.42-1.42A20 20 0 0016 7z" })));
}
exports.default = SvgConnectOutline;
//# sourceMappingURL=ConnectOutline.js.map